import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";

const DisabledField: FC<{ label: string }> = ({ label }) => (
  <Stack gap="8px" flex={1} minWidth="240px">
    <Typography variant="cap12" color={text.primary}>
      {label}
    </Typography>
    <Box
      sx={{
        height: "33px",
        display: "flex",
        alignItems: "center",
        px: "8px",
        borderRadius: rounded.xs,
        border: `1px solid ${divider.middle}`,
        background: background.disable,
      }}
    />
  </Stack>
);

export const PasswordResetSection: FC = () => {
  return (
    <Stack gap="8px">
      <Typography variant="sub16Semi" color={text.primary}>
        パスワードの再設定
      </Typography>

      <Stack direction="row" gap="24px" flexWrap="wrap">
        <DisabledField label="現在のパスワード" />
        <Stack flex={1} minWidth={0} />
      </Stack>

      <Stack direction="row" gap="24px" flexWrap="wrap">
        <DisabledField label="新しいパスワード" />
        <DisabledField label="新しいパスワード（確認用）" />
      </Stack>

      <Typography variant="cap12" color={text.secondary}>
        新しいパスワードに変更する場合は、右下の編集ボタンを押してください。
      </Typography>
    </Stack>
  );
};
